import {
  CookieCategory,
  getBrowserCookies,
  setBrowserCookie,
} from '@moonpig/web-core-browser-storage'
import { PERSISTED_FILTERS } from '@moonpig/web-core-brand/config'
import { ApplicableFilter } from '../../services/types/services'

export const isPersistedFilter = (filter: ApplicableFilter) => {
  return Boolean(PERSISTED_FILTERS[filter.id])
}

export const persistFilterSelection = (
  filter: ApplicableFilter,
  select: boolean,
) => {
  const filterValue = PERSISTED_FILTERS[filter.id]

  /* istanbul ignore else */
  if (filterValue) {
    setBrowserCookie(
      filterValue,
      select.toString(),
      {
        path: '/',
      },
      CookieCategory.STRICTLY_NECESSARY,
    )
  }
}

export const getPersistedFilters = () => {
  const cookies = getBrowserCookies()
  return Object.keys(PERSISTED_FILTERS).reduce((acc, filterId) => {
    if (cookies[PERSISTED_FILTERS[filterId]] === 'true') {
      acc.push(filterId)
    }
    return acc
  }, [] as string[])
}
